import React from "react";
import { Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, Button } from "@fluentui/react-components";
import { Dismiss24Regular, ArrowLeft16Regular, ArrowRight16Regular } from "@fluentui/react-icons";
import { SuggestedRedlines } from "@/components/suggested-redlines";
import { DocumentClassification } from "@/types/risk-analysis";

interface RiskAnalysisDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedRule: DocumentClassification["rules"][number] | null;
  isLoadingPlaybook: boolean;
  currentIndex: number;
  onNavigate: (direction: "prev" | "next") => void;
  styles: Record<string, string>;
  onRefreshAnalysis: () => void;
}

export const RiskAnalysisDialog: React.FC<RiskAnalysisDialogProps> = ({
  open,
  onOpenChange,
  selectedRule,
  isLoadingPlaybook,
  currentIndex,
  onNavigate,
  styles,
  onRefreshAnalysis,
}) => {
  if (!selectedRule) return null;
  return (
    <Dialog open={open} onOpenChange={(_, data) => onOpenChange(data.open)}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle className={styles.dialogTitleContainer}>
            <div className={styles.dialogTitle}>
              <span>
                Clause Analysis for <b>{selectedRule.clauseTopic}</b>
              </span>
              <Button icon={<Dismiss24Regular />} onClick={() => onOpenChange(false)} aria-label="Close" />
            </div>
            {selectedRule.paragraphs?.length > 0 && (
              <div className={styles.navigationControls}>
                <div className={styles.navigationButtons}>
                  <Button
                    disabled={isLoadingPlaybook || selectedRule.isLoading}
                    icon={<ArrowLeft16Regular />}
                    onClick={() => onNavigate("prev")}
                    aria-label="Previous"
                  />
                  <Button
                    disabled={isLoadingPlaybook || selectedRule.isLoading}
                    icon={<ArrowRight16Regular />}
                    onClick={() => onNavigate("next")}
                    aria-label="Next"
                  />
                  <span>
                    {currentIndex + 1}/{selectedRule.paragraphs?.length}
                  </span>
                </div>
              </div>
            )}
          </DialogTitle>
          <DialogContent>
            <div>
              <div className={styles.fullReportListItem}>
                <strong className={styles.fullReportListItemTitle}>Report:</strong>
                <ul>
                  {selectedRule?.analysis?.clause?.fullReport?.map((line: string, index: number) => (
                    <li key={`${line}-${index}`}>{line.replace("-", "")}</li>
                  ))}
                </ul>
              </div>
              <p className={styles.fullReportListItem}>
                <strong className={styles.fullReportListItemTitle}>Customer rule:</strong>
                {selectedRule?.analysis?.clause?.preferredLanguage
                  ?.replace("Customer Rule: ", "")
                  ?.split("\n")
                  ?.map((line: string, index: number) => <span key={`${line}-${index}`}>{line}</span>)}
              </p>
              <div className={styles.fullReportListItem}>
                <strong className={styles.fullReportListItemTitle}>Suggested redlines:</strong>
                <SuggestedRedlines rule={selectedRule} onRefreshAnalysis={onRefreshAnalysis} />
              </div>
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
